module.exports = __webpack_public_path__ + "img/radios-frame.9e66f9c5.gif";